import axios from "axios";
import { endpoints } from "config/api";
import { getAuthToken } from "utils/helper";

export const getSellerList = async (params) => {
  let request = await axios({
    method: "GET",
    url: endpoints.payments.GET_ALL_SELLER,
    headers: {
      Authorization: getAuthToken(),
    },
    params: params,
  });
  return request;
};

export const checkSellerUsingID = async(id)=>{
  let request = await axios({
    url: `${endpoints.payments.CHECK_SELLER_ID}?sellerId_by_user=${id}`,
    method:'GET',
    headers:{
      Authorization:getAuthToken()
      },
  })
  return request;
}

export const getPaymentHistory = async (params) => {
  let request = await axios({
    method: "GET",
    url: endpoints.payments.PAYMENT_HISTORY,
    headers: {
      Authorization: getAuthToken(),
    },
    params: params
  });
  return request
}

export const getSellerById = async (id) => {
  let request = await axios({
    method: "GET",
    url: `${endpoints.payments.GET_SELLER_BY_ID}?sellerId_by_user=${id}`,
    headers: {
      Authorization: getAuthToken(),
    },
  });
  return request;
};

export const deleteSellerById = async (data) => {
  let request = await axios({
    method: "PUT",
    url: endpoints.payments.DELETE_SELLER_BY_ID,
    headers: {
      Authorization: getAuthToken(),
    },
    data: data,
  });
  return request;
};

export const addNewSeller = async (data) => {
  let request = await axios({
    method: "POST",
    url: endpoints.payments.ADD_NEW_SELLER,
    headers: {
      Authorization: getAuthToken(),
    },
    data: data,
  });
  return request;
};

//Create New payment process
export const crateNewPaymentProcess = async (data) => {
  let request = await axios({
    method: "POST",
    url: endpoints.payments.CREATE_NEW_PAYMENT,
    headers: {
      Authorization: getAuthToken(),
    },
    data: data,
  });
  return request;
};

export const updatePaymentStatus = async (data) => {
  let request = await axios({
    method: "PUT",
    url: endpoints.payments.UPDATE_PAYMENT_STATUS,
    headers: {
      Authorization: getAuthToken(),
    },
    data: data,
  });
  return request;
};

export const editSellerById = async (data) => {
  let request = await axios({
    method: "PUT",
    url: endpoints.payments.EDIT_SELLER,
    headers: {
      Authorization: getAuthToken(),
    },
    data: data,
  });
  return request;
};
